<template>
  <div>
    <h2 class="Trio-form-title">Información sobre ti</h2>
    <div class="Trio-form-group">
      <div class="Trio-form-item">
        <label for="name" class="Trio-label">Nombre</label>
        <input
          id="name"
          v-model="name"
          name="name"
          type="text"
          placeholder="Nombre"
        />
      </div>
      <div class="Trio-form-item">
        <label for="surname" class="Trio-label">Apellidos</label>
        <input
          id="surname"
          v-model="surname"
          name="surname"
          type="text"
          placeholder="Apellidos"
        />
      </div>
    </div>
    <div class="Trio-form-group">
      <div class="Trio-form-item">
        <label for="email" class="Trio-label">Correo electrónico</label>
        <input
          id="email"
          v-model="email"
          name="email"
          type="email"
          placeholder="Correo electrónico"
        />
        <p v-if="!isValidEmail" class="Trio-error-form">
          Por favor, rellena el campo con un email válido
        </p>
      </div>
      <div class="Trio-form-item">
        <label for="phone" class="Trio-label">Teléfono</label>
        <input
          id="phone"
          v-model="phone"
          name="phone"
          type="text"
          placeholder="Teléfono"
          minlength="9"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "../store/index";

export default {
  name: "personalForm",
  props: ["isValidEmail"],
  data() {
    return {
      hasEmailError: false,
    };
  },
  computed: {
    name: {
      get() {
        return Store.getters["personalData/name"];
      },
      set(name) {
        Store.commit("personalData/SET_NAME", name);
      },
    },
    surname: {
      get() {
        return Store.getters["personalData/surname"];
      },
      set(surname) {
        Store.commit("personalData/SET_SURNAME", surname);
      },
    },
    email: {
      get() {
        return Store.getters["personalData/email"];
      },
      set(email) {
        Store.commit("personalData/SET_EMAIL", email);
      },
    },
    phone: {
      get() {
        return Store.getters["personalData/phone"];
      },
      set(phone) {
        Store.commit("personalData/SET_PHONE", phone);
      },
    },
  },
};
</script>